module.exports = __webpack_public_path__ + "/login_ui/img/ye-1f97c10baa72bc5943e5f62c9be7111b.svg";